module.exports = __webpack_public_path__ + "media/images/faramia/logistique_thumbnail-ab525b060a761dbbeb1d4aa3c22c731a.png";